import snackbar from '@@containers/Snackbar';

export const showErrorMessage = (error) =>
    snackbar.error(error.message, { title: error.title || error.code });
